import styled from 'styled-components';

const CodeBlock = styled.pre`
overflow: auto;
`;

export default CodeBlock;